// extracted by mini-css-extract-plugin
export var root = "mqZq_drHKKAMEN1tZ9ym";